import { Component, inject } from '@angular/core';
import { LegalLayoutComponent } from '@app/legal/layout/layout.component';
import { ContactsService } from '@services/contacts.services';

@Component({
  selector: 'app-legal-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  imports: [LegalLayoutComponent],
})
export class LegalTermsOfUseComponent {
  private contactService = inject(ContactsService);
  email = this.contactService.email;
  phone = this.contactService.phone;
}
